import { useTranslation } from 'react-i18next';
import { LocalizedContent } from '@/types';

export function useLocalized() {
    const { i18n } = useTranslation();

    const getLocalized = (content: LocalizedContent | null | undefined): string => {
        if (!content) return '';

        if (typeof content === 'string') {
            if (content.trim().startsWith('{')) {
                try {
                    const parsed = JSON.parse(content);
                    if (typeof parsed === 'object' && parsed !== null) {
                        return getLocalized(parsed);
                    }
                } catch (e) {
                    // Ignore error, treat as simple string
                }
            }
            return content;
        }

        if (typeof content === 'object') {
            const lang = i18n.language; // e.g., 'pl', 'en-US'

            // Try exact match
            if (content[lang]) return content[lang];

            // Try base language (e.g. 'en' from 'en-US')
            const baseLang = lang.split('-')[0];
            if (content[baseLang]) return content[baseLang];

            // Fallback to English
            if (content['en']) return content['en'];

            // Fallback to first available key
            const keys = Object.keys(content);
            if (keys.length > 0) return content[keys[0]];
        }

        return String(content);
    };

    return { getLocalized };
}
